<div class="title">
  <span>{{ getTitle(cr) }}</span>
</div>
<!-- CR classique -->
<div class="date" *ngIf="cr.type === 'cr-view' || (cr.type === 'cr-response' && cr.ot?.numero_ot)">
  <span>
    <b>{{ cr.ot.numero_ot }}</b>
    -
    <b>
      <span *ngIf="cr.ot.site">
        {{ cr.ot.site.libelle_long }}
      </span>
    </b>
  </span>
</div>

<!-- CR NON Planifié envoyé -->
<div class="date" *ngIf="cr.type === 'cr-response' && !cr.ot.numero_ot">
  <span *ngIf="cr.ot.site">
    {{ cr.ot.site.libelle_long }}
  </span>
</div>
<!-- CR NON Planifié brouillon -->
<div class="date" *ngIf="cr.type === 'chrono-input'">
  <span>
    <b>{{ $any(cr).site_name }}</b>
  </span>
</div>
<!-- Cr en cours d'envoi-->
<div class="date" *ngIf="cr.type === 'post-cr-request'">
  <span>
    <b>{{ cr.ot.numero_ot }}</b>
    -
    <b>
      <span *ngIf="$any(cr).site_libelle">
        {{ $any(cr).site_libelle }}
      </span>
    </b>
  </span>
</div>
@if (cr.type === 'cr-view' || cr.type === 'cr-response' || cr.type === 'post-cr-request') {
  @if (cr.commentaire_client) {
    <div class="date ellipsis">
      <span>Commentaire au client: {{ cr.commentaire_client }}</span>
    </div>
  }
  @if (cr.commentaire_manager) {
    <div class="date ellipsis">
      <span>Commentaire interne: {{ cr.commentaire_manager }}</span>
    </div>
  }
}

<div *ngIf="cr.type === 'cr-view' || cr.type === 'cr-response'" class="date">
  @if (cr.intervention_date_fin) {
    <span>{{ cr.intervention_date_fin | date: 'dd/MM/yyyy à HH:mm' }}</span>
  } @else {
    <span>{{ 'CR.DATE_INCONNUE' | translate }}</span>
  }
</div>
<div *ngIf="cr.type === 'post-cr-request'" class="date">
  @if (cr.intervention_date_fin) {
    <span>{{ cr.intervention_date_fin | date: 'dd/MM/yyyy à HH:mm' }}</span>
  } @else {
    <span>{{ 'CR.DATE_INCONNUE' | translate }}</span>
  }
</div>
<div *ngIf="cr.type === 'chrono-input'" class="date">
  @if (cr.date_modification_intervenant) {
    <span>{{ cr.date_modification_intervenant | date: 'dd/MM/yyyy à HH:mm' }}</span>
  } @else {
    <span>{{ 'CR.DATE_INCONNUE' | translate }}</span>
  }
</div>
<div *ngIf="cr.type === 'cr-response' || cr.type === 'cr-view'" class="date">
  <ion-icon color="medium" *ngIf="cr.ot.est_rdv_client" name="today-outline"></ion-icon>
</div>
<div class="status">
  @if (cr.type === 'post-cr-request') {
    <span>{{ 'CR.EN_COURS_ENVOI' | translate }}</span>
  } @else {
    <span>{{ 'CR.ENVOYE' | translate }}</span>
  }
</div>
